module.exports = __webpack_public_path__ + "static/media/aWBTC-logo.72d1e651.png";